export default "__VITE_ASSET__DQnMEwG4__"